import {SelectOption} from "@bolteu/kalep-react";

export const isDriverSelected = (driver: SelectOption | null) => !!driver?.value && driver?.value !== -1;
